<div class="as-rewards-container">
    <div class="icon-container">
        <mat-icon (click)="closeModal()" class="as-pointer" svgIcon="ic-close-green"></mat-icon>
    </div>
    <p class="as-font-black-gray as-roboto-slab as-font-bold as-font-18">{{ data.name }}</p>
    <p class="as-font as-font-12 as-font-black-gray">{{ data.description }}</p>
</div>